(function () {
    'use strict';

    angular
        .module('app.addInfluencerToInfluencerGroup', [])
        .controller('addInfluencerToInfluencerGroupCtrl', ['$scope', '$rootScope', '$stateParams', '$modal', '$http', '$modalInstance', 'addInfluencerToInfluencerGroupService',
            function ($scope, $rootScope, $stateParams, $modal, $http, $modalInstance, addInfluencerToInfluencerGroupService) {

                $scope.influencersToBeAdded = [];
            	$scope.closeModal = function() {
            		$modalInstance.close();
            	}

                $scope.saveInfluencerManualAddedToInfluencerGroup = function(){
                    var req = {
                        url: $rootScope.apiUrl + 'influencerGroup/saveInfluencerManualAddedToInfluencerGroup',
                        method: 'POST',
                        data: {}
                    }
                    
                    var varBlogs = function () {
                        var array = [];

                        $scope.influencersToBeAdded.forEach(function(item){
                            array.push(item.id);
                        })
                        
                        return array;
                    }
                    
                    req.data.influencerList = varBlogs();

                    req.data.influencer_group_id = $scope.influencer_group_id;
                    $http(req).success(function(response){
                        //close modal
                        $modalInstance.close({ reload: true });
                    });            
                }

                //delete item from list
                $scope.deleteInfluencer = function(index){
                    $scope.influencersToBeAdded.splice(index, 1);
                }

                $scope.availableTags = function(val) {
                    $scope.errorMessage = "";
                    return $http.get($rootScope.apiUrl + 'domain', {
                        loader: true,
                        params: {
                            find: val
                        }
                    }).then(function(response) {  
                        return response.data;
                    }, function(response) {
                        if(response.data != null) {
                            if(response.data.message != null) {
                                var errorModalInstance = $modal.open({
                                    scope: $scope,
                                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                    windowClass: 'modal-dialog-mention-error'
                                });
                                $scope.errorModalInstance = errorModalInstance;
                                $scope.errorMessage = response.data.message;
                            }
                        }
                    });
                };

                $scope.afterSelectTag = function(item){
                    var currentBlogIds = $scope.manualAddedInfluencerList.map(function(row){
                        return row.influencer_id
                    })

                    var newBlogIds = $scope.influencersToBeAdded.map(function(row){
                        return row.id
                    })
                    
                    if (currentBlogIds.indexOf(item.id) === -1 && newBlogIds.indexOf(item.id) === -1) {
                        $scope.influencersToBeAdded.push(item);
                    } else if(currentBlogIds.indexOf(item.id) !== -1 || newBlogIds.indexOf(item.id) !== -1) {
                        addInfluencerToInfluencerGroupService.getInfluencerGroupNameForAddInfluencerError($scope.influencer_group_id, $scope.company_id, item.id)
                            .then(function(response) {
                                $scope.influencerGroupNameForAddInfluencerError = response.data;
                                var errorModalInstance = $modal.open({
                                    scope: $scope,
                                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                    windowClass: 'modal-dialog-mention-error'
                                });
                                $scope.errorModalInstance = errorModalInstance;
                                $scope.errorMessage = "This Influencer is already added to " + $scope.influencerGroupNameForAddInfluencerError + ".";
                            })
                    }

                    $scope.selectedTag = ""; 
                }
            }
        ])

})();